// @mui
import { Box, Card, Paper, Typography, CardHeader, CardContent, CardProps } from '@mui/material';
// utils
import { fShortenNumber } from '../../../../utils/formatNumber';

import StorefrontIcon from '@mui/icons-material/Storefront';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import ConstructionIcon from '@mui/icons-material/Construction';

// ----------------------------------------------------------------------

interface Props extends CardProps {
  title?: string;
  subheader?: string;
  list?: {
    id:number;
    key: string;
    value: number;
    // icon: React.ReactElement;
  }[];
}

export default function ShopBasedOnStatus({ title, subheader, list, ...other }: Props) {
  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />

      <CardContent>
        <Box
          sx={{
            display: 'grid',
            gap: 2,
            gridTemplateColumns: 'repeat(2, 1fr)',
          }}
        >
          {list?.map((site) => (
            <Paper key={site.key} variant="outlined" sx={{ py: 2.5, textAlign: 'center' }}>
              {site.id === 7 ? (
                <Box sx={{ position: 'relative', display: 'inline-flex',mb: 0.5  }}>
                  <StorefrontIcon sx={{ fontSize: 50, color: 'success.main' }} />
                  <CheckCircleIcon
                    sx={{
                      fontSize: 24,
                      color: 'success.dark',
                      position: 'absolute',
                      bottom: 0,
                      right: 0,
                    }}
                  />
                </Box>
              ) : site.id === 9 ? (
                <ConstructionIcon sx={{ fontSize: 70, color: 'warning.main' }} />
              ) : (
                <StorefrontIcon sx={{ fontSize: 64, color: 'gray' }} />
              )}

              <Typography variant="h6">{fShortenNumber(site.value)}</Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {site.key}
              </Typography>
            </Paper>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
